<template>
  <div class="soilScreen">
    <header class="header">
      <!-- <img class="logo-img" src="../../assets/image/column_nav/col_logo.png" /> -->
      <span class="header-title">
        {{ farmInfo.name ? farmInfo.name : "大旭智能数字农场管理平台" }}
      </span>
    </header>
    <div class="content-box">
      <div class="left-box">
        <div class="charts-box">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!airHOnline"
              />
            </div>

            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>{{ isAirHTitle ? "空气湿度(采样)" : "空气湿度" }}</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
                @click="changeData('airH')"
              />
            </div>
          </div>
          <div class="charts-data-box air-ball-box" v-show="airHNum">
            <div class="air-ball-data">{{ airHNum }}%</div>
            <v-chart class="air-ball" autoresize :option="ballOption"></v-chart>
          </div>
          <div v-if="!airHNum" class="empty-box">暂无设备</div>
        </div>
        <div class="charts-box">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!airTOnline"
              />
            </div>
            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>空气温度</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
              />
            </div>
          </div>
          <div class="charts-data-box air-temperature">
            <div class="weather">
              <i class="img" :class="'qi-' + weatherObj.icon + '-fill'"></i>
            </div>
            <div class="progress-box" v-show="airTNum">
              <div class="line" :style="{ width: airTWidth + '%' }">
                <div class="num-box">{{ airTNum }}℃</div>
              </div>
            </div>
            <div v-if="!airTNum" class="empty-box">暂无设备</div>
          </div>
        </div>
        <div class="charts-box light">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!illOnline"
              />
            </div>
            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>光照强度</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
              />
            </div>
          </div>
          <div v-if="lightShow" class="empty-box">暂无设备</div>
          <div ref="charts-light" class="charts-data-box light"></div>
        </div>
      </div>
      <div class="conter-box">
        <div class="cycle-box">
          <div id="advert">
            <vue-particles
              class="ym-particles"
              color="#fff"
              :particleOpacity="0.4"
              :particlesNumber="30"
              shapeType="circle"
              :particleSize="4"
              linesColor="#fff"
              :linesWidth="1"
              :lineLinked="true"
              :lineOpacity="0.4"
              :linesDistance="30"
              :moveSpeed="2"
              :hoverEffect="true"
              hoverMode="grab"
              :clickEffect="true"
              clickMode="push"
            />
            <div class="bg_img"></div>
            <div class="bg1">
              <div
                class="out-box"
                :class="{
                  bg1_view: start,
                  active: start,
                }"
                v-if="info.counts"
              >
                <div
                  class="cycle-item"
                  :class="item.img"
                  v-for="(item, index) in info.counts"
                  :key="index"
                >
                  <img
                    :src="
                      $imgOnlineUrl + '/huoqiu/analyse/' + item.img + '.png'
                    "
                    :class="'icon0' + item.img"
                  />
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div
              class="content"
              :class="{ content_active: end }"
              @click="getAnalysis"
            >
              <span>{{ info.new_img.title }}</span>
              <img
                :src="
                  $imgOnlineUrl + '/huoqiu/analyse/' + info.new_img.img + '.png'
                "
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- <div class="row-charts-box"> -->
        <div class="charts-box">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!atmOnline"
              />
            </div>
            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>大气压力</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
              />
            </div>
          </div>
          <div ref="charts-pressure" class="charts-data-box pressure"></div>
          <div v-if="pressureShow" class="empty-box">暂无设备</div>
        </div>

        <!-- </div> -->
      </div>
      <div class="right-box">
        <div class="charts-box">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!rainFOnline"
              />
            </div>
            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>降雨量</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
              />
            </div>
          </div>
          <div ref="charts-rainfall" class="charts-data-box rainfall"></div>
          <div v-if="rainfallShow" class="empty-box">暂无设备</div>
        </div>
        <div class="charts-box">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!windDOnline"
              />
            </div>
            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>风向</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
              />
            </div>
          </div>
          <div ref="charts-direction" class="charts-data-box direction"></div>
          <div v-if="directionShow" class="empty-box">暂无设备</div>
        </div>
        <div class="charts-box light">
          <div class="charts-title">
            <div class="switch-box">
              <img
                class="warning"
                src="@/assets/image/analyse/warning.png"
                alt=""
                v-show="!windSOnline"
              />
            </div>
            <div class="title-box">
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
              <span>风速</span>
              <img
                class="title_icon"
                src="@/assets/image/analyse/title_icon.png"
                alt=""
              />
            </div>
            <div class="switch-box">
              <img
                class="switch"
                src="@/assets/image/analyse/switch.png"
                alt=""
              />
            </div>
          </div>
          <div ref="charts-potassium" class="charts-data-box potassium"></div>
          <div v-if="potassiumShow" class="empty-box">暂无设备</div>
        </div>
      </div>
    </div>
    <el-dialog
      class="analysis-pop"
      title=" "
      :visible.sync="isAnalysisPopShow"
      width="860px"
      :before-close="analysisPopClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="analysis-main">
        <div class="ware-title">AI数据分析</div>
        <div class="analysis-content">
          <div
            class="analysis-item"
            v-for="item in deviceDataList"
            :key="item.id"
          >
            <div class="analysis-show-box" v-if="item.isResult">
              <div class="analysis-item-title">{{ item.title }}</div>
              <div class="analysis-item-data">
                <span>当前数值：</span
                ><span>{{ item.last_data }}{{ item.data_unit }}</span>
              </div>
              <div class="analysis-item-data">
                <span>适宜数值：</span>
                <span v-if="item.alias === 'airT'">
                  {{ info.new_img.minNum }}{{ item.data_unit }}~{{
                    info.new_img.maxNum
                  }}{{ item.data_unit }}
                </span>
                <span v-if="item.alias === 'windS'">
                  低于
                  {{ info.new_img.windSNum }}{{ item.data_unit }}
                </span>
              </div>
              <div
                :class="[
                  'analysis-item-result',
                  item.isResult === 1
                    ? 'normal'
                    : item.isResult === 2
                    ? 'high'
                    : item.isResult === 3
                    ? 'low'
                    : '',
                ]"
              >
                {{
                  item.isResult === 1
                    ? "正常"
                    : item.isResult === 2
                    ? "偏高"
                    : item.isResult === 3
                    ? "偏低"
                    : "暂无"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllMarkDataApi,
  getEquipmentListApi,
  getEquipmentInfoApi,
  getEquipmentChildListApi,
  getEquipmentChildListInfoApi,
} from "@/request/api";
import moment from "moment";

import VChart, { THEME_KEY } from "vue-echarts";
import { mapState } from "vuex";
export default {
  provide: {
    [THEME_KEY]: "dark",
  },
  components: {
    VChart,
  },
  data() {
    return {
      isAirHTitle: false,
      isAnalysisPopShow: false,
      lightShow: true,
      pressureShow: true,
      rainfallShow: true,
      directionShow: true,
      potassiumShow: true,
      airHOnline: 0,
      airTOnline: 0,
      rainFOnline: 0,
      windSOnline: 0,
      windDOnline: 0,
      atmOnline: 0,
      illOnline: 0,
      monthDay: "",
      airHNum: "",
      airTNum: "",
      airTWidth: 0,
      monthEnd_day: "",
      nowShowMonth: "",
      channel_id: "",
      lists: [],
      deviceDataList: [],

      customColor: "#2BFDFF",
      weatherObj: {},
      position: "",

      ballOption: {
        backgroundColor: "transparent",
        grid: {
          top: "20%",
          bottom: "18%",
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "liquidFill",
            data: [
              {
                value: 0,
                direction: "right",
                itemStyle: {
                  color: "rgba(10,58,92,0.8)",
                },
              },
              {
                value: 0,
                direction: "right",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(13,90,134,.8)",
                      },

                      {
                        offset: 1,
                        color: "#34DAFB",
                      },
                    ],
                    global: false,
                  },
                },
              },
            ],
            backgroundStyle: {
              color: "#0B0C40",
            },
            itemStyle: {
              opacity: 0.95,
            },
            label: {
              fontSize: 18,
              fontFamily: "cursive",
              formatter: function (params) {
                return `${(params.value * 100).toFixed(1)}%`;
              },
            },
            outline: {
              show: false,
            },
            radius: "98%",
            waveAnimation: 8,
            amplitude: 8,
          },
          {
            name: "",
            type: "pie",
            radius: ["100%", "100%"],
            silent: true,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },
            animationDuration: 2500,
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 1,
                name: "",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 1,
                    y: 0,
                    x2: 0,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgb(6,35,62)",
                      },

                      {
                        offset: 0.5,
                        color: "rgb(144,178,223)",
                      },
                      {
                        offset: 1,
                        color: "rgb(55,171,229)",
                      },
                    ],
                    global: false,
                  },
                },
              },
            ],
          },
        ],
      },
      start: false,
      end: false,
      loading: false,
      info: {
        new_img: { minNum: 8, maxNum: 20, windSNum: 17 },
        counts: [],
      },
      cycleList: [
        // {
        //   img: "chengshu",
        //   title: "成熟期",
        //   minNum: 8,
        //   maxNum: 20,
        //   date: [9, 10],
        //   isActive: false,
        // },
        {
          img: "guanjiangqi",
          title: "灌浆期",
          minNum: 13,
          windSNum: 17,
          maxNum: 23,
          // date: [8, 9],
          date: [9],
          isActive: false,
        },
        {
          img: "kaihuaqi",
          title: "开花期",
          minNum: 17,
          windSNum: 17,
          maxNum: 25,
          // date: [7, 8],
          date: [8],
          isActive: false,
        },
        {
          img: "fenhuaqi",
          title: "分化期",
          minNum: 16,
          windSNum: 17,
          maxNum: 23,
          date: [7],
          // date: [6, 7],
          isActive: false,
        },
        {
          img: "fennieqi",
          title: "分蘖期",
          minNum: 8,
          windSNum: 17,
          maxNum: 22,
          // date: [6, 7],
          date: [6],
          isActive: false,
        },
        {
          img: "miaoqi",
          title: "苗期",
          minNum: 20,
          windSNum: 17,
          maxNum: 30,
          date: [4, 5],
          isActive: false,
        },
      ],

      // 定时器
      setInterval: null,
      setInterval2: null,
      allDataList: {},
      cameraList: [],
      option: null,
      chartsRainfall: null,
      chartsPressure: null,
      chartsLight: null,
      chartsPotassium: null,
      chartsDirection: null,
      chartsTemperature: null,
    };
  },
  computed: {
    ...mapState({
      farmID: (state) => state.user.farmID,
      userInfo: (state) => state.user.userInfo,
      farmList: (state) => state.app.farmList,
      farmInfo: (state) => state.user.farmInfo,
    }),
  },
  created() {
    // this.position = this.farmList.find((t) => t.id == this.farmID).position;
    // if (Array.isArray(this.position)) {
    //   this.position = this.position.join(",");
    // }
    this.allFunction();
    this.updatePage();
    this.handleCycle();
  },
  mounted() {
    this.chartsLight = this.$echarts.init(this.$refs["charts-light"]);
    this.chartsPressure = this.$echarts.init(this.$refs["charts-pressure"]);
    this.chartsRainfall = this.$echarts.init(this.$refs["charts-rainfall"]);
    this.chartsPotassium = this.$echarts.init(this.$refs["charts-potassium"]);
    this.chartsDirection = this.$echarts.init(this.$refs["charts-direction"]);
    this.getAllMarkDataApi();
  },

  beforeDestroy() {
    // 卸载定时器
    if (this.setInterval) {
      clearInterval(this.setInterval);
    }
    this.setInterval = null;
    if (this.setInterval2) {
      clearInterval(this.setInterval2);
    }
    this.setInterval2 = null;
  },

  methods: {
    hecheng() {
      if (this.loading) {
        return false;
      }
      let num = 1;
      this.start = true; // 开启周围动画
      this.loading = true; // 更改按钮状态
      const time = setInterval(() => {
        num++;
        // 转动到5秒时 中间内容动画开始
        if (num == 5) {
          this.end = true;
        }
        // 周围动画结束
        if (num == 7) {
          this.start = false;
        }
        // 8秒后 中间内容动画结束，处理后续逻辑
        if (num == 8) {
          num = 1; // 重置计数器
          this.end = false; // 重置中间动画
          clearInterval(time); // 清除计时器
          if (!this.end) {
            // 动画结束后
            this.loading = false; // 按钮状态
            // this.info.counts = [];
          }
        }
      }, 1000);
    },
    analysisPopClose() {
      this.isAnalysisPopShow = false;
    },
    changeData(type) {
      switch (type) {
        case "airH":
          this.isAirHTitle = !this.isAirHTitle;

          break;

        default:
          break;
      }
    },
    // 设备列表
    async getEquipmentList() {
      this.channel_id =
        this.$route.query.id || localStorage.getItem("equipmentId");
      const { code, results } = await getEquipmentListApi({
        manor_id: this.farmID,
        channel_id: this.channel_id,
      });
      if (code === 0 && results) {
        this.lists = results;
        this.getEquipmentChildList(this.lists[0].id);
      }
    },
    // 设备节点列表 眼
    async getEquipmentChildList(table_id) {
      const { code, results } = await getEquipmentChildListApi({
        manor_id: this.farmID,
        table_id,
        page_size: 20,
      });
      if (code === 0 && results) {
        results.forEach((item) => {
          this.getEquipmentInfoApi_status(table_id, item.icon);

          switch (item.icon) {
            case "rainF":
              this.changeDate(item.id, item.icon);
              break;
            case "ill":
              this.changeDate(item.id, item.icon);
              break;
            case "windD":
              this.changeDate(item.id, item.icon);
              break;
            case "windS":
              this.changeDate(item.id, item.icon);
              break;
            case "atm":
              this.changeDate(item.id, item.icon);
              break;
            default:
              break;
          }
        });

        this.deviceDataList = results;
        this.$forceUpdate();
      }
    },
    async changeDate(child_id, icon) {
      let day = moment(new Date()).format("YYYY-MM-DD");
      const { results } = await getEquipmentChildListInfoApi({
        manor_id: this.farmID,
        table_id: this.lists[0].id,
        child_id,
        day,
        end_day: day,
        act: "history",
      });
      switch (icon) {
        case "ill":
          this.initLightCharts(results.data);
          break;
        case "atm":
          this.initPressureEchart(results.data);
          break;
        case "rainF":
          this.initRainfallEchart(results.data);
          break;
        case "windD":
          this.initDirectionEchart(results.data);
          break;
        case "windS":
          this.initPotassiumEchart(results.data);

          break;

        default:
          break;
      }
    },
    getAnalysis() {
      this.isAnalysisPopShow = true;
      const index = this.deviceDataList.findIndex(
        (item) => item.alias === "airT"
      );
      if (index != -1) {
        const last_data = this.deviceDataList[index].last_data;
        if (
          last_data > this.info.new_img.minNum &&
          last_data < this.info.new_img.maxNum
        ) {
          this.deviceDataList[index]["isResult"] = 1;
        } else if (last_data > this.info.new_img.maxNum) {
          this.deviceDataList[index]["isResult"] = 2;
        } else {
          this.deviceDataList[index]["isResult"] = 3;
        }
      }
      // 风速 windS
      const windSIndex = this.deviceDataList.findIndex(
        (item) => item.alias === "windS"
      );
      if (windSIndex != -1) {
        const windSLast_data = this.deviceDataList[windSIndex]?.last_data;
        if (windSLast_data > this.info.new_img.windSNum) {
          this.deviceDataList[windSIndex]["isResult"] = 2;
        } else {
          this.deviceDataList[windSIndex]["isResult"] = 1;
        }
      }
    },
    // 设备详情
    async getEquipmentInfoApi_status(table_id, icon) {
      const { results } = await getEquipmentInfoApi({
        manor_id: this.farmID,
        table_id,
        act: "status",
      });
      if (icon === "airH") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "airH";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.airHNum = results.data[keys].last_data || 0;
            this.airHOnline = results.data[keys].online || 0;
            this.ballOption.series[0].data[0].value = this.airHNum / 100;
            this.ballOption.series[0].data[1].value = this.airHNum / 100 - 0.08;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      } else if (icon === "airT") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "airT";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.airTNum = results.data[keys].last_data || 0;
            this.airTOnline = results.data[keys].online || 0;
            this.airTWidth = this.airTNum < 0 ? 0 : this.airTNum;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      } else if (icon === "ill") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "ill";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.illOnline = results.data[keys].online || 0;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      } else if (icon === "rainF") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "rainF";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.rainFOnline = results.data[keys].online || 0;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      } else if (icon === "windD") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "windD";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.windDOnline = results.data[keys].online || 0;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      } else if (icon === "windS") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "windS";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.windSOnline = results.data[keys].online || 0;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      } else if (icon === "atm") {
        const keyIndex = this.deviceDataList.findIndex((item) => {
          return item.alias === "atm";
        });
        let data1 = this.deviceDataList[keyIndex]?.number;
        for (let keys in results.data) {
          if (results.data[keys].number == data1) {
            this.atmOnline = results.data[keys].online || 0;
            this.deviceDataList[keyIndex].last_data = Number(
              results.data[keys].last_data
            );
          }
        }
      }
    },
    // 眼
    handleCycle() {
      const date = new Date();
      const month = date.getMonth() + 1;
      if (month > 9) {
        this.info.new_img = {
          img: "chengshuqi",
          title: "成熟期",
          date: [10],
          minNum: 8,
          windSNum: 17,
          maxNum: 20,
        };
        this.info.counts = [];
        return;
      }
      this.cycleList.forEach((item) => {
        if (item.date.includes(month)) {
          this.info.new_img = {
            img: item.img,
            title: item.title,
            date: item.date,
            minNum: item.minNum,
            windSNum: item.windSNum,
            maxNum: item.maxNum,
          };
        } else {
          this.info.counts.push({
            img: item.img,
            title: item.title,
            date: item.date,
            windSNum: item.windSNum,
            minNum: item.minNum,
            maxNum: item.maxNum,
          });
        }
      });
    },
    initDirectionEchart(results) {
      this.directionShow = false;
      let option_bar = {
        grid: {
          top: "18%",
          bottom: "12%",
          right: "5%",
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: false,
        },
        yAxis: {
          name: "单位",
          nameLocation: "end",
          nameGap: 14,
          nameTextStyle: {
            fontSize: 12,
            align: "right",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(45, 60, 92, 0.3)",
            },
          },
          type: "value",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#FD0D3A",
          borderColor: "#FD0D3A",
          padding: [7, 12],
          formatter: "时间：{b}<br/> 风向：{c}",
          textStyle: {
            color: "#fff",
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "line",
            data: [],
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: "rgb(253, 13, 58, 1)",
              width: 2,
            },
            itemStyle: {
              borderWidth: 2,
              borderColor: "#FD0D3A",
              color: "#fff",
            },
            areaStyle: {
              color: {
                type: "linearGradient",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253, 13, 58,.28)",
                  },
                  {
                    offset: 1,
                    color: "rgba(59,237,222,0)",
                  },
                ],
              },
            },
          },
        ],
      };
      option_bar["xAxis"]["data"] = [];
      option_bar["series"][0]["data"] = [];
      results.forEach((a) => {
        let date = new Date(a["x"]);
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let xAxis = h + ":" + date.getMinutes();
        option_bar["xAxis"]["data"].push(xAxis);
        option_bar["series"][0]["data"].push(a["y"]);
      });
      option_bar["yAxis"]["name"] = "单位：度";
      this.chartsDirection.setOption(option_bar);
    },
    initPotassiumEchart(results) {
      this.potassiumShow = false;
      let option_bar = {
        grid: {
          top: "14%",
          bottom: "10%",
          right: "5%",
          left: "12%",
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: false,
        },
        yAxis: {
          name: "单位",
          nameLocation: "end",
          nameGap: 14,
          nameTextStyle: {
            fontSize: 12,
            align: "right",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(45, 60, 92, 0.3)",
            },
          },
          type: "value",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#3BEDDE",
          borderColor: "#3BEDDE",
          padding: [7, 12],
          formatter: "时间：{b}<br/> 风速：{c}",
          textStyle: {
            color: "#fff",
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "line",
            data: [],
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: "rgb(59,237,222)",
              width: 2,
            },
            itemStyle: {
              borderWidth: 2,
              borderColor: "#3BEDDE",
              color: "#fff",
            },
            areaStyle: {
              color: {
                type: "linearGradient",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(59,237,222,.28)",
                  },
                  {
                    offset: 1,
                    color: "rgba(59,237,222,0)",
                  },
                ],
              },
            },
          },
        ],
      };
      option_bar["xAxis"]["data"] = [];
      option_bar["series"][0]["data"] = [];
      results.forEach((a) => {
        let date = new Date(a["x"]);
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let xAxis = h + ":" + date.getMinutes();
        option_bar["xAxis"]["data"].push(xAxis);
        option_bar["series"][0]["data"].push(a["y"]);
      });
      option_bar["yAxis"]["name"] = "单位：m/s";
      this.chartsPotassium.setOption(option_bar);
    },

    initPressureEchart(results) {
      this.pressureShow = false;
      let option_bar = {
        grid: {
          top: "12%",
          bottom: "10%",
          right: "5%",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(54, 148, 252, 0.8)",
          borderColor: "rgba(54, 148, 252, 0.8)",
          padding: [7, 12],
          formatter: "时间：{b}<br/> 压强：{c}",
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(45, 60, 92, 0.3)",
            },
          },
          z: 10,
        },
        yAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#999",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(45, 60, 92, 0.3)",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            showBackground: true,
            barMaxWidth: 14,
            itemStyle: {
              borderRadius: [14, 14, 0, 0],
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(54, 148, 252, .6)" },
                { offset: 1, color: "rgba(54, 222, 252, .6)" },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(54, 148, 252, .6)" },
                  { offset: 1, color: "rgba(54, 222, 252, .6)" },
                ]),
              },
            },
            data: [],
          },
        ],
      };
      option_bar["xAxis"]["data"] = [];
      option_bar["series"][0]["data"] = [];
      results.forEach((a) => {
        let date = new Date(a["x"]);
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let xAxis = h + ":" + date.getMinutes();
        option_bar["xAxis"]["data"].push(xAxis);
        option_bar["series"][0]["data"].push(a["y"]);
      });
      option_bar["yAxis"]["name"] = "单位：hPa";
      this.chartsPressure.setOption(option_bar);
    },

    initRainfallEchart(results) {
      this.rainfallShow = false;
      let option_bar = {
        grid: {
          top: "18%",
          bottom: "12%",
          right: "5%",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(45, 60, 92, 0.8)",
          borderColor: "rgba(45, 60, 92, 0.8)",
          padding: [7, 12],
          formatter: "时间：{b}<br/> 降雨量：{c}",
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "rgba(45, 60, 92, 0.3)",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            data: [],
            barMaxWidth: 14,
            itemStyle: {},
          },
        ],
      };

      option_bar["xAxis"]["data"] = [];
      option_bar["series"][0]["data"] = [];
      results.forEach((a) => {
        let date = new Date(a["x"]);
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let xAxis = h + ":" + date.getMinutes();
        option_bar["xAxis"]["data"].push(xAxis);
        option_bar["series"][0]["data"].push(a["y"]);
      });
      option_bar["yAxis"]["name"] = "单位：mm";

      this.chartsRainfall.setOption(option_bar);
    },
    initLightCharts(results) {
      this.lightShow = false;
      let option_bar = {
        grid: {
          top: "14%",
          bottom: "10%",
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            color: "#fff",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#999",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(45, 60, 92, 0.3)",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            showBackground: true,
            barMaxWidth: 14,
            itemStyle: {
              borderRadius: [14, 14, 0, 0],
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(54, 148, 252, .6)" },
                { offset: 1, color: "rgba(54, 222, 252, .6)" },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(54, 148, 252, .6)" },
                  { offset: 1, color: "rgba(54, 222, 252, .6)" },
                ]),
              },
            },
            data: [],
          },
        ],
      };
      option_bar["xAxis"]["data"] = [];
      option_bar["series"][0]["data"] = [];
      results.forEach((a) => {
        let date = new Date(a["x"]);
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let xAxis = h + ":" + date.getMinutes();
        option_bar["xAxis"]["data"].push(xAxis);
        option_bar["series"][0]["data"].push(a["y"]);
      });
      option_bar["yAxis"]["name"] = "单位：Lux";
      this.chartsLight.setOption(option_bar);
    },
    async getAllMarkDataApi() {
      const { code, results } = await getAllMarkDataApi({
        manor_id: this.farmID,
      });
      if (code === 0) {
        this.cameraList = results;

        results.forEach((item) => {
          if (item.group !== "地块") {
            this.allDataList[item.group] = [];
            item.items.forEach((item2) => {
              let obj = {
                position: "",
                title: "",
                img: "",
              };
              let iconType = "";
              if (item2.icon === "video") {
                iconType = "video";
              } else if (item2.icon === "weather") {
                iconType = "weather";
              } else {
                iconType = "water";
              }

              obj.img = `${this.$imgOnlineUrl}/index/${iconType}${item2.online}.png`;
              obj.title = item.group;
              obj.id = item2.id;
              obj.online = item2.online;
              obj.iconType = iconType;
              obj.icon = item2.icon;
              obj.position = [
                +item2.mark_data.split(",")[0],
                +item2.mark_data.split(",")[1],
              ];
              this.allDataList[item.group].push(obj);
            });
          }
        });
      }
    },

    allFunction() {
      this.getEquipmentList();
    },
    // //30分钟更新一次
    updatePage() {
      this.setInterval2 = setInterval(() => {
        this.allFunction();
      }, 1800000);
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes animtran {
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
}

@keyframes alwaysRotate {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  50% {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  100% {
    transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
  }
}

@-webkit-keyframes animtran {
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
}
@keyframes animtrans {
  from {
    transform: rotateZ(360deg) scale(0);
    opacity: 0;
  }
  to {
    transform: rotateZ(0deg);
    opacity: 1;
  }
}
@-webkit-keyframes animtrans {
  from {
    transform: rotateZ(360deg) scale(0);
    opacity: 0;
  }
  to {
    transform: rotateZ(0deg);
    opacity: 1;
  }
}
@keyframes jumpBoxHandler {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 8px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes rotation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
.soilScreen {
  width: 100vw;
  height: 100vh;
  background: url(../../assets/image/analyse/bg.png) no-repeat #0b195c;
  background-size: cover;
  .header {
    width: 100%;
    height: 113px;
    background: url(../../assets/image/analyse/head_bg.png) center center
      no-repeat;
    background-size: cover;
    line-height: 113px;
    text-align: center;
    position: relative;
    .logo-img {
      width: 82px;
      position: absolute;
      top: 7%;
      left: 41px;
    }
    .header-title {
      font-family: Adobe Heiti Std;
      font-weight: normal;
      font-size: 36px;
      letter-spacing: 2px;

      background: linear-gradient(
        180deg,
        #eaeffb 0%,
        #cae7fc 51%,
        #abd8fa 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .content-box {
    width: 100%;
    height: calc(100% - 113px);
    display: flex;
    justify-content: space-between;
    .right-box,
    .conter-box,
    .left-box {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 0;
        background-color: #3e90e5;
      }
      .charts-box {
        width: 545px;
        height: 277px;
        background: transparent;
        border: 1px solid #3694fc;
        box-shadow: 0 0 4px 1px #3694fc;
        margin-bottom: 10px;
        position: relative;
        &.light {
          height: 345px;
        }
        .empty-box {
          width: 100%;
          height: 100%;
          font-size: 16px;
          color: #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9999;
        }
        .charts-title {
          width: 100%;
          height: 56px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 33px;

          .warning {
            width: 37px;
          }
          .title-box {
            width: 400px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            &::after {
              content: "";
              width: 100%;
              height: 1px;
              background: linear-gradient(to right, #131962, #348ef4, #131962);
              position: absolute;
              bottom: -13px;
              left: 50%;
              transform: translateX(-50%);
            }
            .title_icon {
              width: 49px;
              height: 24px;
              &:nth-of-type(2) {
                transform: rotate(180deg);
              }
            }
            span {
              font-family: Adobe Heiti Std;
              font-weight: normal;
              font-size: 20px;
              color: #fff;
              margin: 0 58px;
            }
          }
          .switch-box {
            width: 37px;
            cursor: pointer;
            &:hover {
              opacity: 0.8;
            }
            .switch {
              width: 100%;
            }
          }
        }
        .charts-data-box {
          width: 100%;
          height: calc(100% - 56px);

          &.air-ball-box {
            width: 450px;
            height: 120px;
            background: #03356e;
            display: flex;
            align-items: center;
            margin: 20px auto;
            padding: 20px 0;
          }
          .air-ball-data {
            width: 172px;
            height: 100%;
            line-height: 80px;
            text-align: center;
            position: relative;
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 20px;
            color: #2bfdff;
            &::after {
              content: "";
              width: 2px;
              height: 100px;
              background: linear-gradient(to bottom, #131962, #31dafb, #131962);
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
            }
          }
          .air-ball {
            width: calc(100% - 172px);
            height: 100%;
          }
          &.air-temperature {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .weather {
              height: 23px;
              position: absolute;
              top: 10px;
              left: 20px;
              .img {
                color: #3e90e5;
                font-size: 36px;
              }
            }
            .progress-box {
              width: 328px;
              height: 14px;
              background: #3694fc;
              border-radius: 7px;
              .line {
                max-width: 100%;
                height: 100%;
                border-radius: 7px;
                background: #2bfdff;
                position: relative;
                .num-box {
                  width: 60px;
                  height: 60px;
                  background: linear-gradient(0deg, #067beb, #1144b4);
                  border-radius: 50%;
                  position: absolute;
                  top: 50%;
                  right: -30px;
                  transform: translateY(-50%);
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  font-size: 16px;
                  color: #fff;
                  line-height: 60px;
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }

    .conter-box {
      width: 810px;
      // flex: 1;

      .cycle-box {
        width: 100%;
        height: calc(100% - 220px);
        #advert {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          position: relative;
          overflow: hidden;
          .ym-particles {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 8;
          }
          .bg_img {
            width: 100%;
            height: 100%;
            background: url(../../assets/image/analyse/cycle_bg0.png) center
              center no-repeat;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            // animation: rotateBg 2s infinite;
            animation: alwaysRotate 3s ease infinite alternate;
            -webkit-animation: alwaysRotate 3s ease infinite alternate;
          }
          .bg1 {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            background: url(../../assets/image/analyse/cycle_bg1.png) center
              center no-repeat;
            background-size: cover;
            .out-box {
              width: 100%;
              height: 100%;
              position: relative;
              background: url(../../assets/image/analyse/cycle_bg2.png) center
                center no-repeat;
              background-size: 100% 100%;
              position: absolute;

              &.bg1_view {
                .cycle-item {
                  img {
                    animation-name: animtrans;
                    animation-duration: 8s;
                    animation-fill-mode: forwards;
                    animation-direction: reverse;
                    animation-iteration-count: infinite;
                    animation-timing-function: cubic-bezier(
                      0.8,
                      0.04,
                      0.02,
                      0.08
                    );
                  }
                }
              }
              &.active {
                .cycle-item {
                  img {
                    animation-name: animtrans;
                    animation-duration: 8s;
                    animation-fill-mode: forwards;
                    animation-direction: reverse;
                    animation-iteration-count: infinite;
                    animation-timing-function: cubic-bezier(
                      0.8,
                      0.04,
                      0.02,
                      0.08
                    );
                  }
                }
              }
              img {
                margin-bottom: 10px;
                &.icon0fenhuaqi {
                  width: 110px;
                  // height: 668px;
                }
                &.icon0kaihuaqi {
                  width: 110px;
                  // height: 171px;
                }
                &.icon0miaoqi {
                  width: 110px;
                  // height: 203px;
                }

                &.icon0guanjiangqi {
                  width: 110px;
                  // height: 185px;
                }
                &.icon0fennieqi {
                  width: 110px;
                  // height: 186px;
                }
                &.icon0chengshuqi {
                  width: 300px;
                  // height: 276px;
                }
              }
              .cycle-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 14px;
                position: absolute;

                &.fenhuaqi {
                  animation: jumpBoxHandler 3s infinite;
                  animation-delay: 0;
                  // top: 14px;
                  // left: 20px;
                }
                &.kaihuaqi {
                  animation: jumpBoxHandler 3s infinite;
                  animation-delay: 0.2s;
                  // bottom: 14px;
                  // left: 20px;
                }
                &.miaoqi {
                  animation: jumpBoxHandler 3s infinite;
                  animation-delay: 0.3s;
                  // bottom: 14px;
                  // right: 20px;
                }
                &.guanjiangqi {
                  animation: jumpBoxHandler 3s infinite;
                  animation-delay: 0.4s;
                  // top: 14px;
                  // right: 20px;
                }
                &.fennieqi {
                  animation: jumpBoxHandler 3s infinite;
                  animation-delay: 0.5s;
                  // top: 8px;
                  // right: 20px;
                }
                &:nth-of-type(1) {
                  top: 14px;
                  left: 20px;
                }
                &:nth-of-type(2) {
                  bottom: 14px;
                  left: 20px;
                }
                &:nth-of-type(3) {
                  bottom: 14px;
                  right: 20px;
                }
                &:nth-of-type(4) {
                  top: 14px;
                  right: 20px;
                }
              }
            }
          }
          .content {
            position: absolute;
            z-index: 12;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) scale(1.7);

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &.content_active {
              -webkit-animation: rotation 2s linear infinite;
              animation: rotation 2s linear infinite;
            }

            img {
              width: 35%;
              cursor: pointer;
            }
            span {
              color: #fff;
              font-size: 14px;
              margin-bottom: 10px;
            }
          }
        }
      }
      .charts-box {
        width: 100%;
        height: 345px;
      }
    }
  }
}
</style>
